import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import ActivationCodeInput from './ActivationCodeInput';
import { AppSettings, DeviceActivations } from '../../../globals/interfaces';
import Icon from '../../../components/custom/Icon';
import _ from 'lodash';
import Settings from './Settings';
import apiClient from '../../../apiClient';
import { notify } from '../../../utils';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedItem: DeviceActivations | undefined;
    updateSettings: (settings: AppSettings) => Promise<void>;
    deactivateDisplay: (deviceId: string) => Promise<void>;
}

export default function ModalUpdate ({
    modal,
    setModal,
    selectedItem,
    updateSettings,
    deactivateDisplay
}: Props) {

    const [settings, setSettings] = useState<AppSettings>();

    useEffect(() => {
        if (selectedItem) {
            setSettings(JSON.parse(selectedItem.settings));
        } else {
            setSettings({});
        }
    }, [selectedItem?.device_id]);

    const toggle = () => setModal(!modal);

    if (!selectedItem) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Manage Device {selectedItem.device_id}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <Settings 
                    settings={settings}
                    setSettings={setSettings}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={true}>
                        <ActionIcon
                            type={'delete'}
                            onClick={() => deactivateDisplay(selectedItem.device_id)}
                            simulateLoading
                        />
                        <ActionIcon
                            type={'check'}
                            onClick={() => updateSettings(settings)}
                            simulateLoading
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;